import React from "react";
import { Link } from "react-router-dom";

const NavCart = () => {
  return (
    <Link to="product/cart">
      <i className="bi bi-cart text-[#007BFF] text-lg"></i>
    </Link>
  );
};

export default NavCart;
